import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Section, Container, Eyebrow, DisplayH1 } from "@/components/Layout";
import { api } from "@/lib/api";
import { MapPin, Globe, Mail, ArrowLeft, Award } from "lucide-react";
import AlumniReviews from "@/components/AlumniReviews";

export default function AlumniDetail() {
  const { id } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => { api.get(`/alumni/${id}`).then((r) => setA(r.data)).catch(() => setA(false)); }, [id]);
  if (a === false) return <Section className="pt-40 pb-40"><Container><DisplayH1>Alumni not found.</DisplayH1><Link to="/alumni" className="btn-ghost mt-6">Back to the directory</Link></Container></Section>;
  if (!a) return <Section className="pt-40 pb-40"><Container><div className="text-[color:var(--wk-bone-dim)]">Loading…</div></Container></Section>;
  return (
    <Section testid="alumnus-page" className="pt-32 pb-32">
      <Container>
        <Link to="/alumni" className="link-underline text-sm text-[color:var(--wk-bone-dim)] inline-flex items-center gap-2">
          <ArrowLeft size={14} /> Back to the directory
        </Link>
        <div className="mt-8 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="relative overflow-hidden rounded-3xl aspect-[4/5]">
              <img src={a.photo_url} alt={a.display_name} className="w-full h-full object-cover" />
              <div className="absolute inset-0 cinema-overlay" />
            </div>
          </div>
          <div className="lg:col-span-7">
            <Eyebrow>{a.program}</Eyebrow>
            <DisplayH1 className="mt-4">{a.display_name}</DisplayH1>
            <div className="mt-2 font-serif-display text-[color:var(--wk-gold)] italic text-2xl leading-snug">{a.headline}</div>
            <div className="mt-6 flex flex-wrap gap-4 text-sm text-[color:var(--wk-bone-dim)]">
              <span className="flex items-center gap-2"><MapPin size={14} className="text-[color:var(--wk-gold)]" /> {a.city}, {a.country}</span>
              {a.year_certified && <span className="flex items-center gap-2"><Award size={14} className="text-[color:var(--wk-gold)]" /> Certified {a.year_certified}</span>}
              {a.website && <a href={a.website} target="_blank" rel="noreferrer" className="flex items-center gap-2 link-underline"><Globe size={14} className="text-[color:var(--wk-gold)]" /> Website</a>}
            </div>
            {a.bio && <p className="mt-8 text-lg text-[color:var(--wk-bone-dim)] leading-relaxed">{a.bio}</p>}
            <div className="mt-8 flex flex-wrap gap-2">
              {(a.specialties || []).map((s) => (
                <span key={s} className="px-3 py-1 rounded-full text-xs border border-white/10 text-[color:var(--wk-bone-dim)]">{s}</span>
              ))}
            </div>
            {a.accepts_clients ? (
              <div className="mt-10 card-lux p-6">
                <div className="font-serif-display text-2xl">Currently accepting new clients.</div>
                <div className="mt-3 text-sm text-[color:var(--wk-bone-dim)]">Reach out through the Wolfkeeper admissions team to be introduced.</div>
                <Link to="/contact" className="btn-gold mt-6">Request introduction</Link>
              </div>
            ) : (
              <div className="mt-10 text-sm text-[color:var(--wk-bone-dim)]">Not currently accepting new clients — check back later.</div>
            )}
          </div>
        </div>
        <AlumniReviews alumniId={a.alumni_id} />
      </Container>
    </Section>
  );
}
